import React from 'react';

const clientDashboard = () => {
    return (
        <>
            <div className="container-fluid">
            </div>
        </>
    );
}

export default clientDashboard;